export const threadKeys = {
    all: ['threads'] as const,
    search: ['threads', 'search'] as const,
    messages: (threadId: string) => ['thread', threadId, 'messages'] as const,
    getThread: (threadId: string) => ['thread', threadId] as const,
}
